import { useBackgroundCanvas } from "@/hooks/useBackgroundCanvas";

interface BackgroundCanvasProps {
  frozen?: boolean;
  className?: string;
}

// Full-viewport background canvas with moving nodes and proximity lines
// Uses design system colors via CSS variables --primary and --accent
const BackgroundCanvas = ({ frozen = false, className = "" }: BackgroundCanvasProps) => {
  const { canvasRef, isReady } = useBackgroundCanvas({ frozen });

  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      className={`fixed inset-0 z-[-1] transition-opacity duration-1000 ease-in-out ${className}`}
      style={{
        display: "block",
        transform: "translateZ(0)",
        opacity: isReady ? 1 : 0
      }}
    />
  );
};

export default BackgroundCanvas;
